export type QuestionAnswerStatistics = OpenQuestionAnswerStatistics | ClosedQuestionAnswerStatistics | MultipleQuestionAnswerStatistics;

export enum ChartTypeEnum {
  bar = 'bar',
  pie = 'pie'
}

export enum QuestionTypeEnum {
  hour = 'hour',
  date = 'date',
  picture = 'picture',
  numeric = 'numeric',
  dropdown = 'dropdown',
  paragraph = 'paragraph',
  signature = 'signature',
  checkboxes = 'checkboxes',
  shortAnswer = 'shortAnswer',
  multipleChoice = 'multipleChoice',
  currency = 'currency',
  email = 'email',
  phone = 'phone',
  document = 'document'
}

export interface DashboardFormsAnswersResult {
  items: DashboardFormsAnswersItem[];
  totalCount: number;
}
export interface DashboardFormsAnswersItem {
  formAnswerCount: number;
  formId: string;
  formName: string;
}

export interface DashboardFormsAnswersDetailResult {
  items: DashboardFormsAnswersDetailItem[];
}

export interface AlternativeQuestionChartResult {
  position: number;
  title: string;
  type: QuestionTypeEnum;
  answers: any[];
}

export interface DashboardFormsAnswersDetailItem {
  title: string;
  position: number;
  type: QuestionTypeEnum;
  chartType?: ChartTypeEnum;
  answers: QuestionAnswerStatistics[];
  charts?: {
    pie: boolean,
    bar: boolean
  };
}

export interface DashboardFormsQuestionIcon {
  type: string;
  icon: string;
}

export interface OpenQuestionAnswerStatistics {
  typeName: string;
  value: string;
  name: string;
}

export interface ClosedQuestionAnswerStatistics {
  typeName: string;
  count: number;
  value: string;
  name: string;
}

export interface MultipleQuestionAnswerStatistics {
  typeName: string;
  values: string[];
}
